import { render } from "./Advertisement.vue?vue&type=template&id=105bc09c&scoped=true&ts=true"
import script from "./Advertisement.vue?vue&type=script&lang=ts"
export * from "./Advertisement.vue?vue&type=script&lang=ts"

import "./Advertisement.vue?vue&type=style&index=0&id=105bc09c&scoped=true&lang=css"

import exportComponent from "D:\\Ventla Code\\New Admin\\node_modules\\@vue\\cli-service\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-105bc09c"]])

export default __exports__